import styled from 'styled-components';
import { Twitter, MessageCircle, Send, Users } from 'lucide-react';

const CommunityContainer = styled.div`
    width: 100%;
    color: white;
    font-family: Very Sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    position: relative;
`;

const CommunityWrapper = styled.div`
    width: 80%;
    margin: 0 auto;
    padding: 3rem 0;
    @media screen and (max-width: 768px) {
    padding: 1rem 0;
    width: 90%;
    }
`;

const Header = styled.div`
    text-align: center;
    margin-bottom: 3rem;
    @media screen and (max-width: 768px) {
    text-align: left;
    }
`;

const Title = styled.h2`
    font-family: Very Sans Headline, Sans Serif;
    font-size: 46px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 1rem 0;

    .highlight {
        background: linear-gradient(135deg, #3B82F6 0%, #a78bfa 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }
`;

const Subtitle = styled.p`
    color: #94A3B8;
    font-size: 16px;
    font-weight: 400;
    max-width: 700px;
    margin: 0 auto;
    line-height: 1.6;
`;

const SocialGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    margin-bottom: 3rem;
    
    @media (max-width: 968px) {
        grid-template-columns: 1fr;
    }
`;

const SocialCard = styled.a`
    background: rgba(255, 255, 255, 0.025);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    transition: all 0.3s ease;
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        background: rgba(255, 255, 255, 0.04);
        border-color: rgba(59, 130, 246, 0.3);
        transform: translateY(-4px);
    }
`;

const SocialHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

const IconWrapper = styled.div`
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: ${props => props.bg || 'rgba(59, 130, 246, 0.1)'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

const SocialInfo = styled.div`
    flex: 1;
`;

const SocialName = styled.h3`
    font-family: Very Sans Bold, Sans Serif;
    font-size: 20px;
    color: #ffffff;
    margin: 0 0 0.25rem 0;
`;

const SocialHandle = styled.div`
    color: #94A3B8;
    font-size: 14px;
    font-family: Very Sans, Sans Serif;
`;

const MemberCount = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #94A3B8;
    font-size: 14px;
    font-family: Very Sans, Sans Serif;
`;

const NewsletterSection = styled.div`
    background: rgba(255, 255, 255, 0.025);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 2.5rem;
    text-align: center;
`;

const NewsletterTitle = styled.h3`
    font-family: Very Sans Bold, Sans Serif;
    font-size: 28px;
    color: #ffffff;
    margin: 0 0 0.75rem 0;
`;

const NewsletterDescription = styled.p`
    color: #94A3B8;
    font-size: 14px;
    font-family: Very Sans, Sans Serif;
    margin: 0 0 2rem 0;
`;

const NewsletterForm = styled.form`
    display: flex;
    gap: 1rem;
    max-width: 600px;
    margin: 0 auto;
    
    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const EmailInput = styled.input`
    flex: 1;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 14px 18px;
    color: #ffffff;
    font-size: 14px;
    font-family: Very Sans, Sans Serif;
    outline: none;
    transition: all 0.3s ease;
    
    &::placeholder {
        color: #94A3B8;
    }
    
    &:focus {
        border-color: rgba(59, 130, 246, 0.5);
        background: rgba(0, 0, 0, 0.3);
    }
`;

const SubscribeButton = styled.button`
    background: #3B82F6;
    color: white;
    border: none;
    padding: 14px 32px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s ease;
    font-family: Very Sans, Sans Serif;
    font-size: 14px;
    white-space: nowrap;
    
    &:hover {
        background: #2563EB;
    }
`;

const GradientOrb1 = styled.div`
    position: absolute;
    top: -20%;
    left: -10%;
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
    pointer-events: none;
`;

const Community = () => {
    const socialLinks = [
        {
            name: 'Twitter',
            handle: '@HydrixApp',
            members: '2.5K+ Members',
            icon: <Twitter size={28} color="#1DA1F2" />,
            bg: 'rgba(29, 161, 242, 0.1)',
            url: 'https://x.com/HydrixApp'
        },
        {
            name: 'App',
            handle: 'Android/ios',
            members: '60K+',
            icon: <MessageCircle size={28} color="#5865F2" />,
            bg: 'rgba(88, 101, 242, 0.1)',
            url: '_blank'
        },
        {
            name: 'Telegram',
            handle: '@HydrixOfficial',
            members: '2K+ Members',
            icon: <Send size={28} color="#0088cc" />,
            bg: 'rgba(0, 136, 204, 0.1)',
            url: 'https://t.me/HydrixApp'
        }
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle newsletter subscription
        const email = e.target.email.value;
        console.log('Subscribe:', email);
    };

    return (
        <CommunityContainer>
            <GradientOrb1 />
            <CommunityWrapper>
                <Header>
                    <Title>Join the <span className="highlight">Community</span></Title>
                    <Subtitle>
                        Be part of the Hydrix revolution. Connect with builders, miners, and enthusiasts worldwide.
                    </Subtitle>
                </Header>

                <SocialGrid>
                    {socialLinks.map((social, index) => (
                        <SocialCard 
                            key={index} 
                            href={social.url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            <SocialHeader>
                                <IconWrapper bg={social.bg}>
                                    {social.icon}
                                </IconWrapper>
                                <SocialInfo>
                                    <SocialName>{social.name}</SocialName>
                                    <SocialHandle>{social.handle}</SocialHandle>
                                </SocialInfo>
                            </SocialHeader>
                            <MemberCount>
                                <Users size={16} />
                                {social.members}
                            </MemberCount>
                        </SocialCard>
                    ))}
                </SocialGrid>

                <NewsletterSection>
                    <NewsletterTitle>Stay Updated</NewsletterTitle>
                    <NewsletterDescription>
                        Subscribe to our newsletter for the latest updates and announcements.
                    </NewsletterDescription>
                    <NewsletterForm onSubmit={handleSubmit}>
                        <EmailInput 
                            type="email" 
                            name="email"
                            placeholder="Enter your email" 
                            required 
                        />
                        <SubscribeButton type="submit">
                            Subscribe
                        </SubscribeButton>
                    </NewsletterForm>
                </NewsletterSection>
            </CommunityWrapper>
        </CommunityContainer>
    );
};

export default Community;